import { useEffect } from 'react';
import { TRobotintConfig, TTintColor } from '../types';
import { getRobotintOptions } from './helpers/get-robotint-options.helper';
import { robotint } from '../components/robotint';
import { PATH_TO_LOAD_ROBOTINT_SCRIPT } from '../pdp-select-tint-color.const';

type TProps = {
  robotintConfig: TRobotintConfig;
  handleSelectColor: (color: Required<TTintColor>) => void;
  productIdAfterVariantChange: string;
};

export const useRobotintScript = ({
  robotintConfig,
  handleSelectColor,
  productIdAfterVariantChange,
}: TProps) => {
  const { clientId, secret, robotintLink } = robotintConfig;

  useEffect(() => {
    const isScriptAddedToPage =
      document.querySelector(`script[src="${robotintLink}${PATH_TO_LOAD_ROBOTINT_SCRIPT}"]`) !== null;
    if (!isScriptAddedToPage && robotintLink.length > 0) {
      const script = document.createElement('script');
      script.async = true;
      script.src = `${robotintLink}${PATH_TO_LOAD_ROBOTINT_SCRIPT}`;
      script.onload = () => {
        import('../components/web-components');

        const robotintOptions = getRobotintOptions({
          clientId,
          secret,
          robotintLink,
          colorSelect: ({ COLOR_NAME, HEX, COLLECTION_NAME }) =>
            handleSelectColor({
              COLOR_NAME,
              HEX,
              COLLECTION_NAME,
            }),
        });

        robotint.setOptions(robotintOptions);
      };
      document.body.append(script);
    }
  });

  useEffect(() => {
    robotint.enableButtons();
  }, [productIdAfterVariantChange]);

  useEffect(() => {
    window.addEventListener('resize', robotint.enableButtons);

    return () => window.removeEventListener('resize', robotint.enableButtons);
  }, []);
};
